// extracted by mini-css-extract-plugin
module.exports = {"s14appjz":"s14appjz","sizeBadge":"sizeBadge","sizeS":"sizeS","sizeM":"sizeM","sizeL":"sizeL"};